import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from '@/pages/Home';
import RedirectPage from '@/pages/Redirect';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/redirect/" element={<RedirectPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;